(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Gae', Gae);

    Gae.$inject = ['$resource', 'DateUtils'];

    function Gae ($resource, DateUtils) {
        var resourceUrl =  'api/gaes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
